import { jsonFetch, clearSession } from '../source/browser-utils.js';

function normalizeMarks(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }
  return [];
}

// -----------------------------
// Main DOMContentLoaded handler
// -----------------------------
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('profileForm');
  const display_name_input = document.getElementById('display_name');
  const occupation = document.getElementById('occupation');
  const region = document.getElementById('profileRegion');
  const bio = document.getElementById('bio');
  const contact_pref_input = document.getElementById('contact_pref');
  const contact_value_input = document.getElementById('contact_value');
  const contact_public_input = document.getElementById('contact_public');
  let pendingRecoveryEmail = null;
  const statusEl = document.getElementById('profileStatus');
  const avatarInput = document.getElementById('profileAvatar');
  const avatarPreview = document.getElementById('avatarPreview');
  let lastMeAdmin = null;
  let currentAvatarUrl = null;
  let pendingAvatarData = null;

  const setProfileAuthState = (isAuthed) => {
    document.documentElement.classList.toggle('profile-auth-only', !isAuthed);
  };

  const estimateDataUrlSize = (dataUrl) => {
    const base64 = (dataUrl && dataUrl.split(',')[1]) || '';
    return Math.ceil((base64.length * 3) / 4);
  };

  const sanitizeMediaSrc = (value) => {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (/^data:image\/[a-z0-9.+-]+;base64,/i.test(raw)) return raw;
    if (/^blob:/i.test(raw)) return raw;
    try {
      const parsed = new URL(raw, window.location.origin);
      if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.toString();
    } catch (_err) {
      // ignore invalid URL values
    }
    return '';
  };

  const compressImageFile = (file, { maxEdge = 720, quality = 0.82, minQuality = 0.42, step = 0.08, targetBytes = 800 * 1024 } = {}) => {
    if (!file) return Promise.resolve({ dataUrl: null, size: 0, isWithinLimit: true });
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();
      reader.onload = (e) => {
        img.onload = () => {
          let { width, height } = img;
          const scale = Math.min(1, maxEdge / Math.max(width, height));
          if (scale < 1) {
            width = Math.round(width * scale);
            height = Math.round(height * scale);
          }
          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          let q = quality;
          let bestDataUrl = null;
          let bestSize = Infinity;
          let within = false;
          while (q >= minQuality) {
            const dataUrl = canvas.toDataURL('image/jpeg', q);
            const size = estimateDataUrlSize(dataUrl);
            if (size < bestSize) {
              bestSize = size;
              bestDataUrl = dataUrl;
              within = size <= targetBytes;
            }
            if (size <= targetBytes) break;
            q = +(q - step).toFixed(2);
          }
          resolve({ dataUrl: bestDataUrl, size: bestSize, isWithinLimit: within });
        };
        img.onerror = reject;
        img.src = e.target.result;
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  };

  const renderAvatarPreview = (src) => {
    if (!avatarPreview) return;
    const initial = ((display_name_input && display_name_input.value) || (authUsername && authUsername.value) || '?')
      .trim()
      .charAt(0)
      .toUpperCase() || '?';
    const safeSrc = sanitizeMediaSrc(src);

    avatarPreview.textContent = '';
    if (safeSrc) {
      const image = document.createElement('img');
      image.src = safeSrc;
      image.alt = 'Profile photo preview';
      avatarPreview.appendChild(image);
      avatarPreview.dataset.initial = '';
    } else {
      const fallback = document.createElement('span');
      fallback.className = 'avatar-fallback';
      fallback.textContent = initial;
      avatarPreview.appendChild(fallback);
      avatarPreview.dataset.initial = initial;
    }
  };

  // Auth UI (may not exist on all pages)
  const authUsername = document.getElementById('authUsername');
  const authPassword = document.getElementById('authPassword');
  const authRecoveryEmail = document.getElementById('authRecoveryEmail');
  const btnRegister = document.getElementById('btnRegister');
  const btnLogin = document.getElementById('btnLogin');
  const btnLogout = document.getElementById('btnLogout');
  const authStatus = document.getElementById('authStatus');
  const adminPanelBtn = document.getElementById('adminPanelBtn');
  const forgotPasswordLink = document.getElementById('forgotPasswordLink');

  const recoveryUpdateForm = document.getElementById('recoveryUpdateForm');
  const recovery_email_input = document.getElementById('recovery_email');
  const recoveryUpdateStatus = document.getElementById('recoveryUpdateStatus');

  const recoveryModal = document.getElementById('recoveryModal');
  const closeRecoveryModal = document.getElementById('closeRecoveryModal');
  const recoveryRequestForm = document.getElementById('recoveryRequestForm');
  const recoveryLookupInput = document.getElementById('recoveryLookupInput');
  const recoveryResetStep = document.getElementById('recoveryResetStep');
  const recoveryCodeInput = document.getElementById('recoveryCodeInput');
  const recoveryNewPassword = document.getElementById('recoveryNewPassword');
  const recoveryResetBtn = document.getElementById('recoveryResetBtn');
  const recoveryStatus = document.getElementById('recoveryStatus');
  const settingsBtn = document.getElementById('settingsBtn');
  const settingsModal = document.getElementById('settingsModal');
  const closeSettingsModal = document.getElementById('closeSettingsModal');
  const settingsNotificationsToggle = document.getElementById('settingsNotificationsToggle');
  const settingsNotificationsStatus = document.getElementById('settingsNotificationsStatus');
  const settingsRecoveryBtn = document.getElementById('settingsRecoveryBtn');
  const settingsProfileBtn = document.getElementById('settingsProfileBtn');
  const settingsLogoutBtn = document.getElementById('settingsLogoutBtn');

  const deriveIsAdmin = (explicit = undefined) => {
    if (typeof explicit === 'boolean') return explicit;
    if (typeof lastMeAdmin === 'boolean') return lastMeAdmin;
    return false;
  };

  const renderAdminStatus = () => {
    return;
  };

  const setAdminButton = (isAdmin) => {
    if (!adminPanelBtn) return;
    adminPanelBtn.style.display = isAdmin ? 'inline-block' : 'none';
    renderAdminStatus();
  };
  if (adminPanelBtn) {
    adminPanelBtn.addEventListener('click', () => {
      window.location.href = 'admin.html';
    });
    setAdminButton(false);
  }

  // ------------- helpers for token -------------
  function setToken(token, userId, isAdmin = null) {
    if (token) localStorage.setItem('lnf_token', token);
    const effectiveAdmin = deriveIsAdmin(isAdmin);
    localStorage.setItem('lnf_is_admin', String(Boolean(effectiveAdmin)));
    if (userId) localStorage.setItem('lnf_user_id', userId);
    setAdminButton(Boolean(effectiveAdmin));
    renderAdminStatus();
    setProfileAuthState(true);
  }

  function clearToken() {
    clearSession();
    if (btnLogout) btnLogout.style.display = 'none';
    if (btnLogin) btnLogin.style.display = '';
    if (btnRegister) btnRegister.style.display = '';
    if (authStatus) authStatus.textContent = '';
    setAdminButton(false);
    renderAdminStatus();
    setProfileAuthState(false);
  }
  window.addEventListener('lnf-auth-changed', () => {
    setProfileAuthState(false);
    if (btnLogout) btnLogout.style.display = 'none';
    if (btnLogin) btnLogin.style.display = '';
    if (btnRegister) btnRegister.style.display = '';
    lastMeAdmin = false;
    setAdminButton(false);
    renderAdminStatus();
  });

  const getNotificationSupport = () => typeof window.Notification !== 'undefined';
  const getStandaloneState = () => window.lnfNotifications?.isStandalone?.() || false;
  const getServiceWorkerSupport = () => 'serviceWorker' in navigator && 'PushManager' in window;
  const setSettingsStatus = (msg) => {
    if (settingsNotificationsStatus) settingsNotificationsStatus.textContent = msg || '';
  };

  const getActiveSubscription = async () => {
    if (!getServiceWorkerSupport()) return null;
    const registration = await navigator.serviceWorker.getRegistration();
    if (!registration) return null;
    return registration.pushManager.getSubscription();
  };

  let notificationRetryDone = false;
  const refreshNotificationSettings = async () => {
    if (!settingsNotificationsToggle) return;
    const supports = getNotificationSupport();
    const isStandalone = getStandaloneState();
    const permission = supports ? Notification.permission : 'unsupported';
    const subscription = supports ? await getActiveSubscription() : null;
    const isEnabled = permission === 'granted' && Boolean(subscription);

    settingsNotificationsToggle.checked = isEnabled;
    settingsNotificationsToggle.disabled = !supports || !isStandalone || permission === 'denied';

    if (!supports) {
      setSettingsStatus('Notifications are not supported in this browser.');
    } else if (!isStandalone) {
      setSettingsStatus('Add LostNFound to your home screen to enable notifications.');
    } else if (permission === 'denied') {
      setSettingsStatus('Notifications are blocked. Enable them in your browser settings.');
    } else if (permission === 'default') {
      setSettingsStatus('Turn on notifications to get message and comment alerts.');
    } else if (!isEnabled) {
      if (!notificationRetryDone) {
        notificationRetryDone = true;
        await window.lnfNotifications?.ensurePushSetup?.();
        return refreshNotificationSettings();
      }
      const pushError = window.lnfNotifications?.getLastPushError?.();
      setSettingsStatus(pushError || 'Notifications are off.');
    } else if (isEnabled) {
      setSettingsStatus('Notifications are on.');
    } else {
      setSettingsStatus('Notifications are off.');
    }
  };

  // ------------- load profile + auth -------------
  async function loadProfile() {
    const requestedToken = localStorage.getItem('lnf_token');
    try {
      const p = await jsonFetch('/api/profile');
      if (!requestedToken || localStorage.getItem('lnf_token') !== requestedToken) return;
      if (contact_public_input) contact_public_input.checked = p.contact_public === true;

      // If the profile form exists, populate it
      if (form) {
        if (display_name_input)  display_name_input.value  = p.display_name || '';
        if (occupation)   occupation.value   = p.occupation   || '';
        if (region)       region.value       = p.region       || '';
        if (bio)          bio.value          = p.bio          || '';
        if (contact_pref_input)  contact_pref_input.value  = p.contact_pref || '';
        if (contact_value_input) contact_value_input.value = p.contact_value || '';
        currentAvatarUrl = p.avatar_url || null;
        pendingAvatarData = null;
        renderAvatarPreview(currentAvatarUrl);
      }

      // Initialize membership UI if membership section exists
      if (document.getElementById('membershipSection')) {
        const membershipProfile = {
          is_member: p.is_member || false,
          member_since: p.member_since || null,
          membership_marks: normalizeMarks(p.membership_marks)
        };
        initMembershipUI(membershipProfile);
      }

      // Try to load auth status
      try {
        const me = await jsonFetch('/api/auth/me');
        if (localStorage.getItem('lnf_token') !== requestedToken) return;
        if (me && me.username) {
          if (me.id) localStorage.setItem('lnf_user_id', me.id);
          if (authStatus) {
            authStatus.textContent = `Signed in as ${me.username}${
              me.display_name ? ' (' + (me.display_name || '') + ')' : ''
          }`;
          }
          setProfileAuthState(true);
          lastMeAdmin = typeof me.is_admin === 'boolean' ? me.is_admin : null;
          if (btnLogout)  btnLogout.style.display  = '';
          if (btnLogin)   btnLogin.style.display   = 'none';
          if (btnRegister) btnRegister.style.display = 'none';
          if (typeof me.is_admin === 'boolean') {
            localStorage.setItem('lnf_is_admin', String(me.is_admin));
            setAdminButton(me.is_admin);
          } else {
            localStorage.setItem('lnf_is_admin', 'false');
            setAdminButton(false);
          }
          renderAdminStatus();
          if (recovery_email_input) recovery_email_input.value = me.recovery_email || '';
        }
      } catch (errAuth) {
        // Not authenticated or endpoint unavailable
        setProfileAuthState(false);
        if (btnLogout)  btnLogout.style.display  = 'none';
        if (btnLogin)   btnLogin.style.display   = '';
        if (btnRegister) btnRegister.style.display = '';
        lastMeAdmin = false;
        localStorage.setItem('lnf_is_admin', 'false');
        setAdminButton(false);
        renderAdminStatus();
      }
    } catch (err) {
      console.error(err);
      if (statusEl) statusEl.textContent = 'Failed to load profile.';
      if (!localStorage.getItem('lnf_token')) setProfileAuthState(false);
    }
  }

  // ------------- save profile -------------
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (statusEl) statusEl.textContent = '';

      const payload = {
        display_name: (display_name_input && display_name_input.value.trim()) || '',
        occupation: (occupation && occupation.value.trim()) || '',
        region: (region && region.value.trim()) || '',
        bio: (bio && bio.value.trim()) || '',
        contact_pref: (contact_pref_input && contact_pref_input.value.trim()) || '',
        contact_value: (contact_value_input && contact_value_input.value.trim()) || '',
        contact_public: contact_public_input?.checked === true
      };

      if (pendingAvatarData) payload.avatar_data = pendingAvatarData;
      else payload.avatar_url = currentAvatarUrl || null;

      try {
        const saved = await jsonFetch('/api/profile', {
          method: 'POST',
          body: JSON.stringify(payload)
        });
        currentAvatarUrl = saved.avatar_url || payload.avatar_data || payload.avatar_url || currentAvatarUrl;
        pendingAvatarData = null;
        renderAvatarPreview(currentAvatarUrl);
        if (statusEl) statusEl.textContent = 'Profile saved.';
      } catch (err) {
        console.error(err);
        if (statusEl) statusEl.textContent = 'Failed to save profile.';
      }
    });
  }

  if (avatarInput) {
    avatarInput.addEventListener('change', async () => {
      const file = avatarInput.files && avatarInput.files[0];
      if (!file) {
        pendingAvatarData = null;
        renderAvatarPreview(currentAvatarUrl);
        return;
      }
      try {
        const { dataUrl, size, isWithinLimit } = await compressImageFile(file);
        if (!dataUrl || !isWithinLimit) {
          const kb = Math.round((size || 0) / 1024);
          if (statusEl) statusEl.textContent = `Image too large after compression (~${kb}KB). Try a smaller square photo.`;
          avatarInput.value = '';
          pendingAvatarData = null;
          renderAvatarPreview(currentAvatarUrl);
          return;
        }
        pendingAvatarData = dataUrl;
        renderAvatarPreview(dataUrl);
        if (statusEl) statusEl.textContent = '';
      } catch (err) {
        console.error('avatar upload error:', err);
        if (statusEl) statusEl.textContent = 'Could not read that image.';
        avatarInput.value = '';
        pendingAvatarData = null;
        renderAvatarPreview(currentAvatarUrl);
      }
    });
  }

  if (display_name_input) {
    display_name_input.addEventListener('input', () => {
      if (!currentAvatarUrl && !pendingAvatarData) renderAvatarPreview(null);
    });
  }

  // ------------- auth handlers -------------
  if (btnRegister) {
    btnRegister.addEventListener('click', async (e) => {
      e.preventDefault();
      if (authStatus) authStatus.textContent = '';
      const u = (authUsername && authUsername.value || '').trim();
      const p = (authPassword && authPassword.value) || '';
      const recovery_email = (authRecoveryEmail && authRecoveryEmail.value || '').trim();

      if (!u || !p) {
        if (authStatus) authStatus.textContent = 'Username and password required.';
        return;
      }
      if (!recovery_email) {
        if (authStatus) authStatus.textContent = 'Recovery email required.';
        return;
      }

      try {
        const res = await jsonFetch('/api/auth/register', {
          method: 'POST',
          body: JSON.stringify({
            username: u,
            password: p,
            display_name: (display_name_input && display_name_input.value.trim()) || null,
            recovery_email: recovery_email || null
          })
        });
        if (res && res.token) {
          setToken(res.token, res.user && res.user.id, res.user && res.user.is_admin);
          if (authStatus) {
            authStatus.textContent =
              `Registered and signed in as ${res.user && res.user.username}`;
          }
          await loadProfile();
        }
      } catch (err) {
        console.error(err);
        if (authStatus) authStatus.textContent = err.message || 'Registration failed.';
      }
    });
  }

  if (btnLogin) {
    btnLogin.addEventListener('click', async (e) => {
      e.preventDefault();
      if (authStatus) authStatus.textContent = '';
      const u = (authUsername && authUsername.value || '').trim();
      const p = (authPassword && authPassword.value) || '';

      if (!u || !p) {
        if (authStatus) authStatus.textContent = 'Username and password required.';
        return;
      }

      try {
        const res = await jsonFetch('/api/auth/login', {
          method: 'POST',
          body: JSON.stringify({ username: u, password: p })
        });
        if (res && res.token) {
          setToken(res.token, res.user && res.user.id, res.user && res.user.is_admin);
          if (authStatus) {
            authStatus.textContent =
              `Signed in as ${res.user && res.user.username}`;
          }
          await loadProfile();
        }
      } catch (err) {
        console.error(err);
        if (authStatus) authStatus.textContent = err.message || 'Login failed.';
      }
    });
  }

  if (btnLogout) {
    btnLogout.addEventListener('click', (e) => {
      e.preventDefault();
      clearToken();
      if (authStatus) authStatus.textContent = 'Signed out.';
    });
  }

  document.getElementById('recoveryConfirmForm')?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const status = document.getElementById('recoveryConfirmStatus');
    try {
      const result = await jsonFetch('/api/auth/recovery/confirm', {
        method: 'POST', body: JSON.stringify({
          recovery_email: pendingRecoveryEmail, code: document.getElementById('recovery_confirm_code')?.value || ''
        })
      });
      clearToken();
      if (status) status.textContent = result.message;
    } catch (error) { if (status) status.textContent = error.message; }
  });
  document.getElementById('passwordChangeForm')?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const status = document.getElementById('passwordChangeStatus');
    const password = document.getElementById('password_new')?.value || '';
    if (password !== document.getElementById('password_confirm')?.value) {
      if (status) status.textContent = 'New passwords do not match.';
      return;
    }
    try {
      const result = await jsonFetch('/api/auth/password', {
        method: 'POST', body: JSON.stringify({
          current_password: document.getElementById('password_current')?.value || '', new_password: password
        })
      });
      event.target.reset();
      clearToken();
      if (authStatus) authStatus.textContent = result.message;
    } catch (error) { if (status) status.textContent = error.message; }
  });

  if (recoveryUpdateForm) {
    recoveryUpdateForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (recoveryUpdateStatus) recoveryUpdateStatus.textContent = '';
      const email = (recovery_email_input && recovery_email_input.value || '').trim();
      if (!email) {
        if (recoveryUpdateStatus) recoveryUpdateStatus.textContent = 'Recovery email required.';
        return;
      }
      try {
        const res = await jsonFetch('/api/auth/recovery/update', {
          method: 'POST',
          body: JSON.stringify({
            recovery_email: email || null,
            current_password: document.getElementById('recovery_current_password')?.value || ''
          })
        });
        pendingRecoveryEmail = res.recovery_email;
        document.getElementById('recoveryConfirmForm')?.classList.remove('is-hidden');
        if (recoveryUpdateStatus) recoveryUpdateStatus.textContent = res.message;
        const currentPassword = document.getElementById('recovery_current_password');
        if (currentPassword) currentPassword.value = '';
        if (res) {
          if (recovery_email_input) recovery_email_input.value = res.recovery_email || '';
        }
      } catch (err) {
        console.error(err);
        if (recoveryUpdateStatus) recoveryUpdateStatus.textContent = err.message || 'Failed to save recovery details.';
      }
    });
  }

  const openRecoveryModal = () => {
    if (!recoveryModal) return;
    if (recoveryRequestForm) recoveryRequestForm.reset();
    if (recoveryResetStep) recoveryResetStep.classList.add('is-hidden');
    if (recoveryCodeInput) recoveryCodeInput.value = '';
    if (recoveryNewPassword) recoveryNewPassword.value = '';
    if (recoveryStatus) recoveryStatus.textContent = '';
    recoveryModal.classList.remove('is-hidden');
  };

  const closeRecovery = () => {
    if (!recoveryModal) return;
    recoveryModal.classList.add('is-hidden');
  };

  if (forgotPasswordLink) {
    forgotPasswordLink.addEventListener('click', (e) => {
      e.preventDefault();
      openRecoveryModal();
    });
  }

  if (closeRecoveryModal) {
    closeRecoveryModal.addEventListener('click', (e) => {
      e.preventDefault();
      closeRecovery();
    });
  }

  if (recoveryModal) {
    recoveryModal.addEventListener('click', (e) => {
      if (e.target === recoveryModal) closeRecovery();
    });
  }

  if (recoveryRequestForm) {
    recoveryRequestForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const recoveryValue = (recoveryLookupInput && recoveryLookupInput.value || '').trim();
      if (!recoveryValue) {
        if (recoveryStatus) recoveryStatus.textContent = 'Enter your recovery email.';
        return;
      }
      if (recoveryStatus) recoveryStatus.textContent = '';
      try {
        const recoveryResult = await jsonFetch('/api/auth/recovery/request', {
          method: 'POST',
          body: JSON.stringify({ recovery_email: recoveryValue })
        });
        if (recoveryResetStep) {
          recoveryResetStep.dataset.recoveryValue = recoveryValue;
          recoveryResetStep.classList.remove('is-hidden');
        }
        if (recoveryStatus) recoveryStatus.textContent = recoveryResult.message;
      } catch (err) {
        console.error(err);
        if (recoveryStatus) recoveryStatus.textContent = err.message || 'Could not request a reset. Please try again.';
      }
    });
  }

  if (recoveryResetBtn) {
    recoveryResetBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      const recoveryValue = recoveryResetStep && recoveryResetStep.dataset.recoveryValue;
      const code = (recoveryCodeInput && recoveryCodeInput.value || '').trim();
      const new_password = (recoveryNewPassword && recoveryNewPassword.value) || '';
      if (new_password !== document.getElementById('recoveryNewPasswordConfirm')?.value) {
        if (recoveryStatus) recoveryStatus.textContent = 'New passwords do not match.';
        return;
      }
      if (!recoveryValue) {
        if (recoveryStatus) recoveryStatus.textContent = 'Start with your recovery email.';
        return;
      }
      if (!code) {
        if (recoveryStatus) recoveryStatus.textContent = 'Enter the recovery code.';
        return;
      }
      if (!new_password) {
        if (recoveryStatus) recoveryStatus.textContent = 'Enter a new password.';
        return;
      }
      if (recoveryStatus) recoveryStatus.textContent = '';
      try {
        const res = await jsonFetch('/api/auth/recovery/verify', {
          method: 'POST',
          body: JSON.stringify({ recovery_email: recoveryValue, code, new_password })
        });
        clearSession();
        if (recoveryStatus) recoveryStatus.textContent = res.message;
      } catch (err) {
        console.error(err);
        if (recoveryStatus) recoveryStatus.textContent = err.message || 'Could not reset password. Check your code and try again.';
      }
    });
  }

  const openSettings = () => {
    if (!settingsModal) return;
    refreshNotificationSettings();
    settingsModal.classList.remove('is-hidden');
  };

  const closeSettings = () => {
    if (!settingsModal) return;
    settingsModal.classList.add('is-hidden');
  };

  if (settingsBtn) {
    settingsBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openSettings();
    });
  }

  if (closeSettingsModal) {
    closeSettingsModal.addEventListener('click', (e) => {
      e.preventDefault();
      closeSettings();
    });
  }

  if (settingsModal) {
    settingsModal.addEventListener('click', (e) => {
      if (e.target === settingsModal) closeSettings();
    });
  }

  if (settingsNotificationsToggle) {
    settingsNotificationsToggle.addEventListener('change', async () => {
      if (!getNotificationSupport()) {
        setSettingsStatus('Notifications are not supported in this browser.');
        settingsNotificationsToggle.checked = false;
        return;
      }
      if (!getStandaloneState()) {
        setSettingsStatus('Add LostNFound to your home screen to enable notifications.');
        settingsNotificationsToggle.checked = false;
        return;
      }
      if (settingsNotificationsToggle.checked) {
        if (Notification.permission === 'denied') {
          setSettingsStatus('Notifications are blocked. Enable them in your browser settings.');
          settingsNotificationsToggle.checked = false;
          return;
        }
        try {
          const permission = await Notification.requestPermission();
          if (permission !== 'granted') {
            setSettingsStatus('Notifications are not enabled.');
            settingsNotificationsToggle.checked = false;
            return;
          }
          notificationRetryDone = false;
          await window.lnfNotifications?.ensurePushSetup?.();
          await refreshNotificationSettings();
        } catch (err) {
          console.error('enable notifications error:', err);
          setSettingsStatus(err?.message || 'Could not enable notifications.');
          settingsNotificationsToggle.checked = false;
        }
      } else {
        try {
          await window.lnfNotifications?.unsubscribePush?.();
          await refreshNotificationSettings();
        } catch (err) {
          console.error('disable notifications error:', err);
          setSettingsStatus('Could not turn off notifications.');
          settingsNotificationsToggle.checked = true;
        }
      }
    });
  }

  if (settingsRecoveryBtn) {
    settingsRecoveryBtn.addEventListener('click', () => {
      closeSettings();
      openRecoveryModal();
    });
  }

  if (settingsProfileBtn) {
    settingsProfileBtn.addEventListener('click', () => {
      closeSettings();
      document.getElementById('profileForm')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  if (settingsLogoutBtn) {
    settingsLogoutBtn.addEventListener('click', () => {
      closeSettings();
      clearToken();
      if (authStatus) authStatus.textContent = 'Signed out.';
    });
  }

  // Initial load
  renderAvatarPreview(currentAvatarUrl);
  setProfileAuthState(Boolean(localStorage.getItem('lnf_token')));
  loadProfile();
});

// -----------------------------
// Membership UI + canvas
// -----------------------------
function initMembershipUI(profile) {
  const statusBlock = document.getElementById('membershipStatusBlock');
  const membershipFormBlock = document.getElementById('membershipFormBlock');
  const currentMarkDisplay = document.getElementById('currentMarkDisplay');

  const drawnBlock = document.getElementById('drawnMarkBlock');
  const agreeCheckbox = document.getElementById('agreeMembership');
  const joinBtn = document.getElementById('joinNetworkBtn');
  const msgEl = document.getElementById('membershipMessage');

  const canvas = document.getElementById('signatureCanvas');
  const clearBtn = document.getElementById('clearCanvasBtn');
  let hasDrawing = false;
  let agreementInfo = null;
  if (joinBtn) joinBtn.disabled = true;
  jsonFetch('/api/membership/agreement').then((agreement) => {
    agreementInfo = agreement;
    const link = document.querySelector('[data-membership-agreement]');
    if (link) link.href = agreement.url;
    if (joinBtn) joinBtn.disabled = false;
  }).catch((error) => { if (msgEl) msgEl.textContent = error.message; });

  // If membership elements aren't present, bail out
  if (!membershipFormBlock || !drawnBlock) {
    return;
  }

  let ctx = null;
  if (canvas) {
    ctx = canvas.getContext('2d');
  }

  // Keep a local copy we can update after saving
  let currentProfile = { ...profile };

  // ------------ status rendering ------------
  function renderCurrentMark(p) {
    if (!currentMarkDisplay) return;

    const marks = p.membership_marks || [];
    const activeMark = marks.find((mark) => mark.used_for_membership) || marks[marks.length - 1];

    if (!activeMark) {
      currentMarkDisplay.textContent = '';
      return;
    }

    currentMarkDisplay.textContent = '';
    if (activeMark.type === 'drawn' && activeMark.data_url) {
      const markSrc = String(activeMark.data_url || '').trim();
      const safeMarkSrc = (/^data:image\/[a-z0-9.+-]+;base64,/i.test(markSrc) || /^blob:/i.test(markSrc) || /^https?:/i.test(markSrc))
        ? markSrc
        : '';
      if (!safeMarkSrc) return;
      const label = document.createElement('p');
      label.className = 'small';
      label.textContent = 'Your current membership mark (drawn):';
      const image = document.createElement('img');
      image.src = safeMarkSrc;
      image.alt = 'Your drawn membership mark';
      image.style.maxWidth = '320px';
      image.style.border = '1px solid #000';
      image.style.borderRadius = '4px';
      currentMarkDisplay.appendChild(label);
      currentMarkDisplay.appendChild(image);
    } else {
      const line = document.createElement('p');
      line.className = 'small';
      line.appendChild(document.createTextNode('Your current membership mark: '));
      const strong = document.createElement('strong');
      strong.textContent = activeMark.value || '(no value recorded)';
      line.appendChild(strong);
      line.appendChild(document.createTextNode(` (${activeMark.label || activeMark.type})`));
      currentMarkDisplay.appendChild(line);
    }
  }

  function renderStatus(p) {
    if (!statusBlock) return;

    if (p.is_member) {
      const joined = p.member_since
        ? new Date(p.member_since).toLocaleString()
        : 'an unknown date';

      statusBlock.textContent =
        `You are a member of the LostNFound Network as of ${joined}.`;

      renderCurrentMark(p);
    } else {
      statusBlock.textContent =
        'You are not yet a member of the LostNFound Network.';
      if (currentMarkDisplay) currentMarkDisplay.textContent = '';
    }
  }

  renderStatus(currentProfile);

  // ------------ drawing logic ------------
  if (canvas && ctx) {
    canvas.style.touchAction = 'none';
    ctx.strokeStyle = '#ceb08d';
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';

    let drawing = false;
    let lastX = 0;
    let lastY = 0;

    const getPos = (event) => {
      const rect = canvas.getBoundingClientRect();
      const scaleX = rect.width ? (canvas.width / rect.width) : 1;
      const scaleY = rect.height ? (canvas.height / rect.height) : 1;
      return {
        x: (event.clientX - rect.left) * scaleX,
        y: (event.clientY - rect.top) * scaleY
      };
    };

    const startDraw = (event) => {
      event.preventDefault();
      drawing = true;
      const pos = getPos(event);
      lastX = pos.x;
      lastY = pos.y;
    };

    const draw = (event) => {
      if (!drawing) return;
      event.preventDefault();
      const pos = getPos(event);
      ctx.beginPath();
      ctx.moveTo(lastX, lastY);
      ctx.lineTo(pos.x, pos.y);
      ctx.stroke();
      hasDrawing = true;
      lastX = pos.x;
      lastY = pos.y;
    };

    const endDraw = (event) => {
      if (event) event.preventDefault();
      drawing = false;
    };

    canvas.addEventListener('pointerdown', startDraw);
    canvas.addEventListener('pointermove', draw);
    canvas.addEventListener('pointerup', endDraw);
    canvas.addEventListener('pointerleave', endDraw);
    canvas.addEventListener('pointercancel', endDraw);

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        hasDrawing = false;
      });
    }
  }

  // ------------ Join / update membership ------------
  if (joinBtn) {
    joinBtn.addEventListener('click', async () => {
      if (msgEl) msgEl.textContent = '';

      if (!agreeCheckbox || !agreeCheckbox.checked) {
        if (msgEl) msgEl.textContent = 'You must agree to the Principles & Guidelines.';
        return;
      }

      let markPayload = {
        mark_type: 'drawn',
        label: 'Drawn mark',
        value: null,
        data_url: null
      };

      if (!canvas) {
        if (msgEl) msgEl.textContent = 'Drawing area not available.';
        return;
      }
      if (!hasDrawing) {
        if (msgEl) msgEl.textContent = 'Please draw your mark before saving.';
        return;
      }
      const dataUrl = canvas.toDataURL('image/png');
      markPayload.data_url = dataUrl;

      try {
        if (!agreementInfo) throw new Error('Load and read the current agreement before joining.');
        const updated = await jsonFetch('/api/membership/join', {
          method: 'POST',
          body: JSON.stringify({ agreed: true, agreement_version: agreementInfo.version, signature_data: markPayload.data_url })
        });

        if (msgEl) msgEl.textContent = 'Membership updated successfully.';

        currentProfile = {
          ...currentProfile,
          is_member: updated.is_member === true,
          member_since: updated.member_since || null,
          membership_marks: normalizeMarks(updated.membership_marks || currentProfile.membership_marks || [])
        };

        renderStatus(currentProfile);
      } catch (err) {
        console.error(err);
        if (msgEl) msgEl.textContent = err.message || 'Failed to update membership.';
      }
    });
  }
}
